export default defineNuxtRouteMiddleware(() => {
  const { isSignatureHost } = useHomeLayoutMode()

  setPageLayout((isSignatureHost ? false : 'default') as 'default')
})
